import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CustomerLoginInput } from '../../inputs';
import { HttpService } from './http.service';
import { LocalStorageService } from '../common/local-storage.service';
import { ActiveUserService } from '../common/active-user.service';
import { CustomerAccessInput, CustomerLoginResponse } from '../../models/common/app-token.model';
import { AuthService } from '@sgm-frontend/core';

@Injectable({
  providedIn: 'root'
})
export class RefreshService extends HttpService<CustomerLoginInput | CustomerAccessInput, CustomerLoginResponse> {
  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string,
    private authService: AuthService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    super(httpClient, apiUrl, apiVersion, 'auth');

  }
  refreshAccessToken(refreshToken: CustomerAccessInput): Observable<void> {
    return this.create(refreshToken, 'refresh').pipe(
      map((res) => {
        if (res && res.data) {
          if (this.localStorageService.checkIsGuest()) {
            this.localStorageService.setGuestToken(res.data);
            // this.localStorageService.setGuestAccessToken(res.data.accessToken);
          } else {
            this.localStorageService.setToken(res.data);
            // this.localStorageService.setAccessToken(res.data.accessToken);
          }

          // this.activeUserService.setActiveUser();
          return res.data; // Must return CustomerrefreshResponse
        } else {
          throw new Error('Invalid response');
        }
      }),
      catchError((error) => {
        console.error('Refresh token failed:', error);
        this.localStorageService.clearTokens(); // Optional
        return throwError(() => error); // Do not return another type
      })
    );
  }

  getGuestTokens() {
    return this.authService
      .guestAuthenticate();
  }



}